<template>
	<div
		:class="[
			settings.cols[cols],
			settings.xs[xs],
			settings.sm[sm],
			settings.md[md],
			settings.lg[lg],
			settings.xl[xl],
			settings['2xl'][xxl],
			settings.order[order],
			offset ? settings.offset : null,
			settings.orderSm[orderSm],
			settings.orderMd[orderMd],
			settings.orderLg[orderLg],
			settings.orderXl[orderXl],
			settings.order2Xl[orderXxl],
			settings.gutter[rowProps.gutter],
			settings.verticalGutter[rowProps.verticalGutter],
		]"
	>
		<slot />
	</div>
</template>

<script setup>
import {inject} from 'vue';
import {defineSettings} from '../composables/component';
const rowProps = inject('props');

const settings = defineSettings('NkCol');
defineProps({
	cols: {
		type: String,
		default: 'full',
		required: false,
	},
	xs: {
		type: String,
		default: null,
		required: false,
	},
	sm: {
		type: String,
		default: null,
		required: false,
	},
	md: {
		type: String,
		default: null,
		required: false,
	},
	lg: {
		type: String,
		default: null,
		required: false,
	},
	xl: {
		type: String,
		default: null,
		required: false,
	},
	xxl: {
		type: String,
		default: null,
		required: false,
	},
	offset: {
		type: Boolean,
		default: false,
		required: false,
	},
	order: {
		type: [String, Number],
		default: null,
		required: false,
	},
	orderSm: {
		type: [String, Number],
		default: null,
		required: false,
	},
	orderMd: {
		type: [String, Number],
		default: null,
		required: false,
	},
	orderLg: {
		type: [String, Number],
		default: null,
		required: false,
	},
	orderXl: {
		type: [String, Number],
		default: null,
		required: false,
	},
	orderXxl: {
		type: [String, Number],
		default: null,
		required: false,
	},
});
</script>
